export const waterAnalysis = (data) => {
    

    if (data.metric === 'salinity') {
        data.units = 'ppt'
        let dataValues = [5, 11, 13, 18, 23, 30]
        let textValues = [
          {type: 'Oligohaline', carbon: "", shellfish: '', level: "low", consid: 'fresh system'},
          {type: 'Mesohaline 1', carbon: '', shellfish: '', level: "moderate", consid: 'brackish, consider salinity dynamics'},
          {type: 'Mesohaline 2', carbon: 'good', shellfish: 'ribbed mussel', level: "moderate", consid: 'good carbon sequestration potential/ribbed mussel'},
          {type: 'Mesohaline 3', carbon: 'high', shellfish: 'ribbed mussel', level: "moderate", consid: 'high carbon sequestration potential/ribbed mussel'},
          {type: 'Mesohaline 4', carbon: 'high', shellfish: 'ribbed mussels and oysters', level: "moderate", consid: 'high carbon sequestration potential/oysters/ribbed mussel'},
          {type: 'Polyhaline', carbon: 'high', shellfish: 'oysters', level: "high", consid: 'high carbon sequestration potential/oysters'},
          {type: 'Mixoeuhaline', carbon: 'high', shellfish: 'oysters', level: "high", consid: 'high carbon sequestration potential/oysters'},
        ]

  
        if (data.currentValue < dataValues[0]) {
          data.salinityStatus = textValues[0]
        } else if (data.currentValue >= dataValues[0] && data.currentValue < dataValues[1]) {
          data.salinityStatus = textValues[1]
        } else if (data.currentValue >= dataValues[1] && data.currentValue < dataValues[2]) {
          data.salinityStatus = textValues[2]
        } else if (data.currentValue >= dataValues[2] && data.currentValue < dataValues[3]) {
          data.salinityStatus = textValues[3]
        } else if (data.currentValue >= dataValues[3] && data.currentValue < dataValues[4]) {
          data.salinityStatus = textValues[4]
        } else if (data.currentValue >= dataValues[4] && data.currentValue < dataValues[5]) {
          data.salinityStatus = textValues[5]
        } else if (data.currentValue >= dataValues[5]) {
          data.salinityStatus = textValues[6]
        } else {
          console.log('salinity data falls outside of logic scheme')
        }
        
}
return data
}